import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/contents/:content_id',
    name: 'Contents',
    component: () => import(/* webpackChunkName: "contents" */ '../views/Page/ContentsView.vue'),
    props: true,
    meta: {
      IsAuth: true
    }
  },
  {
    path: '/categorys/:catid',
    name: 'Categorys',
    component: () => import(/* webpackChunkName: "categorys" */ '../views/Page/CategorysView.vue'),
    props: true,
  },
  {
    path: '/searchs/:search_id',
    name: 'Searchs',
    component: () => import(/* webpackChunkName: "searchs" */ '../views/Page/SearchsView.vue'),
    props: true,
  },
  {
    path: '/signin',
    name: 'signin',
    component: () => import(/* webpackChunkName: "signin" */ '../views/User/LoginView.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/User/ProfileView.vue'),
    meta: {
      IsAuth: true
    }
  },
  {
    path: '/subscribes',
    name: 'Subscribes',
    component: () => import(/* webpackChunkName: "subscribes" */ '../views/User/SubscribesView.vue')
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import(/* webpackChunkName: "contacts" */ '../views/Page/ContactsView.vue'),
    meta: {
      IsAuth: true
    }
  },
  {
    path: '/unsubscribes',
    name: 'Unsubscribes',
    component: () => import(/* webpackChunkName: "unsubscribes" */ '../views/User/UnsubscribesView.vue'),
    // meta: {
    //   IsAuth: true
    // }
  },
  {
    path: '/:pathMatch(.*)*', 
    name: 'NotFounds',
    component: () => import(/* webpackChunkName: "notFounds" */ '../views/Page/NotFoundsView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

// Auth utilities
const authUtils = {
  // Check if user is authenticated based on required cookies
  isAuthenticated(cookie) {
    return cookie.isCookieAvailable("msisdn") && cookie.isCookieAvailable("status");
  },
  
  // Check subscription status if needed in the future
  checkSubscriptionStatus(cookie) {
    return cookie.isCookieAvailable("status") ? cookie.getCookie("status") : null;
  },
  
  // Get redirect path based on authentication failure
  getRedirectPath() {
    return '/Subscribes';
  },

  // Store original path to redirect after authentication
  saveTargetPath(to) {
    if (to.path !== '/Subscribes' && to.path !== '/signin') {
      localStorage.setItem('authRedirect', to.fullPath);
    }
  }
};

router.beforeEach(async (to, from, next) => {
  const { $cookie } = router.app.config.globalProperties;
  
  // Check if route requires authentication
  if (to.meta.IsAuth) {
    if (authUtils.isAuthenticated($cookie)) {
      // User is authenticated, proceed
      next();
    } else {
      // Store the intended destination for redirect after login
      authUtils.saveTargetPath(to);
      
      // Redirect to subscription/login page
      next(authUtils.getRedirectPath());
    }
  } else if (to.path === '/Subscribes' || to.path === '/signin') {
    // For login/subscribe pages, check if user is already authenticated
    if (authUtils.isAuthenticated($cookie)) {
      // If a redirect was stored and user is now authenticated, use it
      const redirectPath = localStorage.getItem('authRedirect');
      if (redirectPath) {
        localStorage.removeItem('authRedirect');
        next(redirectPath);
      } else {
        // Otherwise go to home page
        next('/');
      }
    } else {
      // User not authenticated and accessing login page, allow
      next();
    }
  } else {
    // Route doesn't require auth
    next();
  }
});


export default router
